import machineDiagram from '@/assets/jog-machine-diagram.webp';
import styles from '@/components/jog/jog.module.css';

/** Machine reference diagram (5-axis orientation). Self-contained / reusable. */
export function AxisDiagram(): JSX.Element {
  return (
    <div className={styles.axisDiagram}>
      <span className={styles.jogSectionTitle}>Machine Axes</span>
      <img
        src={machineDiagram}
        alt="5-axis machine axis orientation"
        className={styles.axisDiagramImg}
      />
    </div>
  );
}
